//CRIANDO ACTION

import { createAction, props } from '@ngrx/store';

//padrão de nomenclatura tudo maiusculo
enum ProfessionalScheduleActionType {
  //textos para acomparnharmos os estados de load professional
  LOAD_PROFESSIONAL_SCHEDULE = '[professional] load professional schedule from api',
  LOAD_PROFESSIONAL_SCHEDULE_SUCCESS = '[professional] load professional schedule from api return success',
  LOAD_PROFESSIONAL_SCHEDULE_ERROR = '[professional] load professional schedule from api return error',
  SAVE_PROFESSIONAL_SCHEDULE = '[professional] save professional schedule from api',
  SAVE_PROFESSIONAL_SCHEDULE_SUCCESS = '[professional] edit professional schedule from api return success',
  EDIT_PROFESSIONAL_SCHEDULE = '[professional] edit professional schedule from api',
  EDIT_PROFESSIONAL_SCHEDULE_SUCCESS = '[professional] edit professional schedule from api return success',
  DELETE_PROFESSIONAL_SCHEDULE = '[professional] delete professional schedule from api',
}
export const loadProfessionalSchedule = createAction(
  ProfessionalScheduleActionType.LOAD_PROFESSIONAL_SCHEDULE
);
export const loadProfessionalScheduleSuccess = createAction(
  ProfessionalScheduleActionType.LOAD_PROFESSIONAL_SCHEDULE_SUCCESS,
  props<{ lista: any[] }>()
);
//vai para o effects
export const saveProfessionalSchedule = createAction(
  ProfessionalScheduleActionType.SAVE_PROFESSIONAL_SCHEDULE,
  props<{ professionalSchedule: any }>()
);
//vai para o reducer
export const saveProfessionalScheduleSuccess = createAction(
  ProfessionalScheduleActionType.SAVE_PROFESSIONAL_SCHEDULE_SUCCESS,
  props<{ professionalSchedule: any }>()
);
//vai para o effects
export const editProfessionalSchedule = createAction(
  ProfessionalScheduleActionType.EDIT_PROFESSIONAL_SCHEDULE,
  props<{ professionalSchedule: any; id: number }>()
);
//vai para o reducer
export const editProfessionalScheduleSuccess = createAction(
  ProfessionalScheduleActionType.EDIT_PROFESSIONAL_SCHEDULE_SUCCESS,
  props<{ professionalSchedule: any }>()
);

export const deleteProfessionalSchedule = createAction(
  ProfessionalScheduleActionType.DELETE_PROFESSIONAL_SCHEDULE,
  props<{ id: any }>()
);
